module.exports = __webpack_public_path__ + "img/redHeadBack.5b64bb83.jpg";